/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/273-checkmark': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.5 2L6 9.5 2.5 6 0 8.5l6 6 10-10z"/>'
  }
})
